import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { HiArrowUpRight } from "react-icons/hi2";
import api from "../../lib/api";

function fmt(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString(); } catch { return iso; }
}

export default function Dashboard() {
  const [posts, setPosts] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const nav = useNavigate();

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/api/admin/posts");
      setPosts(data.posts || []);
      setError(null);
    } catch (e) {
      setError(e?.response?.data?.error || e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const filtered = posts.filter((p) => filter === "all" || p.status === filter);

  const togglePublish = async (p) => {
    const next = p.status === "published" ? "draft" : "published";
    await api.patch(`/api/admin/posts/${p.id}`, { status: next });
    load();
  };

  const remove = async (p) => {
    if (!window.confirm(`Delete "${p.title}"? This cannot be undone.`)) return;
    await api.delete(`/api/admin/posts/${p.id}`);
    load();
  };

  return (
    <div>
      <div className="admin-head">
        <div>
          <span className="eyebrow">Studio</span>
          <h1 style={{ marginTop: 8 }}>Posts</h1>
        </div>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          {["all", "draft", "published"].map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setFilter(f)}
              className="chip"
              style={{
                cursor: "pointer",
                background: filter === f ? "var(--accent)" : "transparent",
                color: filter === f ? "#0a0a0a" : "var(--text-soft)",
                borderColor: filter === f ? "var(--accent)" : "var(--border-strong)",
                textTransform: "capitalize",
              }}
            >
              {f}
            </button>
          ))}
          <button type="button" className="btn" onClick={() => nav("/admin/new")}>
            New post
            <span className="arrow"><HiArrowUpRight /></span>
          </button>
        </div>
      </div>

      {loading && <p className="text-muted">Loading…</p>}
      {error && <p style={{ color: "var(--danger)" }}>{error}</p>}

      {!loading && !error && (
        <div className="admin-card" style={{ padding: 0 }}>
          {filtered.length === 0 ? (
            <div style={{ padding: 36, textAlign: "center", color: "var(--muted)" }}>
              No posts yet. <Link to="/admin/new" style={{ color: "var(--accent)" }}>Create your first one</Link> — or use AI to draft one.
            </div>
          ) : (
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Category</th>
                  <th>Status</th>
                  <th>Updated</th>
                  <th>Published</th>
                  <th style={{ textAlign: "right" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((p) => (
                  <tr key={p.id}>
                    <td>
                      <Link to={`/admin/edit/${p.id}`}>{p.title || "Untitled"}</Link>
                      <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 4 }}>
                        /{p.slug}
                      </div>
                    </td>
                    <td style={{ fontSize: 13 }}>
                      {p.category ? (
                        <span className="chip" style={{ padding: "4px 10px" }}>{p.category}</span>
                      ) : (
                        <span style={{ color: "var(--muted)" }}>—</span>
                      )}
                    </td>
                    <td><span className={`status-pill ${p.status}`}>{p.status}</span></td>
                    <td style={{ color: "var(--muted)", fontSize: 13 }}>{fmt(p.updatedAt)}</td>
                    <td style={{ color: "var(--muted)", fontSize: 13 }}>{fmt(p.publishedAt)}</td>
                    <td style={{ textAlign: "right" }}>
                      <div style={{ display: "inline-flex", gap: 8 }}>
                        <button type="button" className="chip" style={{ cursor: "pointer" }} onClick={() => togglePublish(p)}>
                          {p.status === "published" ? "Unpublish" : "Publish"}
                        </button>
                        <Link className="chip" to={`/admin/edit/${p.id}`}>Edit</Link>
                        <button type="button" className="chip" style={{ cursor: "pointer", color: "var(--danger)", borderColor: "rgba(255,107,107,0.3)" }} onClick={() => remove(p)}>
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
